module.exports = __webpack_public_path__ + "static/media/cards@2x.ffe941c2.png";